/**
 * @generated SignedSource<<1d7b511d6fa8cd8af1ca740b12679bef>>
 * @relayHash 5f6aa90814ec1e2db85d75ea9d2b794d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4edfb3aa9ecb438b9bd58c0f0247ccb31535e02c4204e70679ed6445814f46d2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSpaPageContainerQuery$variables = {
  cloudId: string;
};
export type JiraSpaPageContainerQuery$data = {
  readonly jira: {
    readonly __typename: "JiraQuery";
    readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
  } | null | undefined;
};
export type JiraSpaPageContainerQuery = {
  response: JiraSpaPageContainerQuery$data;
  variables: JiraSpaPageContainerQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider: {
    readonly get: () => boolean;
  };
});

import bannerAnnouncementViaSpa_provider from '@atlassian/jira-relay-provider/src/banner-announcement-via-spa.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "BannerContent"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraAnnouncementBanner",
                "kind": "LinkedField",
                "name": "announcementBanner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visibility"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4edfb3aa9ecb438b9bd58c0f0247ccb31535e02c4204e70679ed6445814f46d2",
    "metadata": {},
    "name": "JiraSpaPageContainerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
    }
  }
};
})();

(node as any).hash = "a479ef4022dc14088b4ee2f82b822798";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
